<div class="bank-transfers-dialog">
  <div class="contenedor_cabecera">
    <div class="contenedor_cancel"></div>
    <div class="cabecera">
      <p>{{ 'events.bankTransfersTitle' | translate }}</p>
    </div>
    <div class="contenedor_cancel">
      <button (click)="onClose()" style="cursor:pointer;">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content class="lista_transferencias">
    @if (transfers.length === 0) {
    <div class="sin_resultados">
      <p>{{ 'events.bankTransfersEmpty' | translate }}</p>
    </div>
    } @else {
    @for (transfer of transfers; track transfer.paymentAttempt?.id) {
    <div class="transferencia_item">
      <div class="transferencia_info">
        <div class="fila_principal">
          <span class="ticket_name">{{ getTicketNames(transfer) }}</span>
          <span class="importe">{{ transfer.paymentAttempt?.amount | currency:'EUR' }}</span>
        </div>
        <div class="fila_detalle">
          <span><strong>{{ 'events.bankTransferTickets' | translate }}:</strong> {{ getTicketsCount(transfer) }}</span>
          <span><strong>{{ 'events.bankTransferDate' | translate }}:</strong>
            {{ transfer.paymentAttempt?.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="fila_detalle">
          <span><strong>{{ 'events.bankTransferBuyer' | translate }}:</strong> {{ transfer.wristband?.data?.data?.name + ' ' + transfer.wristband?.data?.data?.surname || '-' }}</span>
        </div>
        <div class="fila_detalle">
          <span><strong>{{ 'events.bankTransferEmail' | translate }}:</strong> {{ transfer.wristband?.data?.data?.email || '-' }}</span>
        </div>
      </div>
      <div class="transferencia_acciones">
        <button class="boton_confirmar" style="cursor:pointer;"
          [disabled]="confirmingId === transfer.paymentAttempt?.id"
          (click)="confirmPayment(transfer)">
          {{ 'events.bankTransferConfirm' | translate }}
        </button>
      </div>
    </div>
    }
    }
  </div>

  @if (showAlert) {
  <div
    style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); width: 90%; max-width: 600px; z-index: 9999;">
    <bracelit-alert [type]="alertType" (closed)="showAlert = false">
      {{ alertMessage }}
    </bracelit-alert>
  </div>
  }
</div>
